export const SENTRY_DEBUG = false;
export const SENTRY_ENABLED = import.meta.env.VITE_NODE_ENV == 'production';
